module.exports = __webpack_public_path__ + "static/media/blogImg4.f45329d4.png";